// PWPOL lane — the singleton gate behind the forced change-password modal (system-admin F5).
//
// Kept framework-free so `src/utils/api.js` can import it from its response interceptor without
// pulling antd/React into that module. `PasswordChangeGate.jsx` renders the modal and settles the
// gate. Same shape as the operator app's 428 ACK gate (src/api/ackGate.js).
export const PASSWORD_CHANGE_EVENT = 'password-change-required';

let pending = null; // { payload, resolve, promise } — one gate at a time

/** True when a response (or a login body) carries the server's PASSWORD_CHANGE_REQUIRED code. */
export function isPasswordChangeRequired(response) {
  const data = response?.data || response;
  return String(data?.code || '').toUpperCase() === 'PASSWORD_CHANGE_REQUIRED';
}

/**
 * Ask the user to change their password. Parallel calls collapse into the one open modal.
 * Resolves `true` once it has been changed, `false` if the user gave up / logged out.
 */
export function requirePasswordChange(payload = {}) {
  if (pending) return pending.promise;
  let resolve;
  const promise = new Promise((r) => {
    resolve = r;
  });
  pending = { payload, resolve, promise };
  try {
    window.dispatchEvent(new CustomEvent(PASSWORD_CHANGE_EVENT, { detail: payload }));
  } catch (e) {
    /* no window (SSR / tests) — the promise simply stays pending */
  }
  return promise;
}

/** Called by the modal when the password was changed (true) or the user backed out (false). */
export function settlePasswordChange(ok) {
  const p = pending;
  pending = null;
  if (p) p.resolve(!!ok);
}

export function isPasswordChangePending() {
  return !!pending;
}
